module.exports = new __parcel__URL__("longdraw.2afc543b.png").toString();